/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { forwardRef, useRef } from 'react'
import { stopGeneratingCompletion } from '../action/chatGPT';
import { SendIcon, StopIcon } from '../LandingHeader/Feedback/icons/Icons';
import { setCurrentPrompt } from '../../redux/slices/AiAssistant';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const PromptInputBox = forwardRef(({focus, setFocus, send, theme, persona, personaRef, removeActivePersona, responseDone, setResponseDone, updateChatContainerHeight, promptInputRef}, ref) => {
    const promptInput = useRef(null);
    const prompt = useSelector(state => state.aiAssistant.prompt);
    const chatData = useSelector(state => state.aiAssistant.chatData);
    const dispatch = useDispatch();
    React.useImperativeHandle(promptInputRef, () => promptInput.current);

    const stopGenerating = (e) => {
        e.preventDefault();
        stopGeneratingCompletion();
        setResponseDone(true);
        
        setTimeout(() => {
            promptInput.current.focus();
        }, 100)
    }

    const toggleSendBtn = (e) => {
        e.target.style.height = '90px';
        updateChatContainerHeight((e.target.scrollHeight < 90 ? 90 : e.target.scrollHeight) + "px");
        promptInput.current.value = e.target.value.replace(/^[\s]+/, '');
        dispatch(setCurrentPrompt(promptInput.current.value));
    }

    return (
        <div ref={ref} className='post-prompt-wrapper light-bg-linear-gradient4 dark:dark-bg-linear-gradient4'>
            {persona && persona.value != 'Default' && <div onClick={removeActivePersona} className='hasOptions has-Prompts' ref={personaRef}>
                <span className='pmt-text active-persona accent-text-color'>Talking to {persona?.label}</span>
                <span className='pmt-text remove'>Remove</span>
            </div>}

            <textarea className="prompt-input chatTextarea placeholder:text-black dark:placeholder:text-white text-black dark:text-white" onKeyDown={e => {
                if(e.key == 'Enter') {
                    e.shiftKey === false && send(e, e.target.value);
                }
                }} value={prompt} ref={promptInput} placeholder={focus ? 'Type something ...' : 'Ask AI ...'} type="text" onInput={toggleSendBtn} onFocus={e => setFocus(true)} css={{
                    textIndent: persona && persona.value != 'Default' ? `${(personaRef?.current?.offsetWidth ?? 0) + 10}px !important` : '0',
                    backgroundPositionX: persona && persona.value != 'Default' ? `${(personaRef?.current?.offsetWidth ?? 0) + 5}px !important` : '0'
                }}>
            </textarea>
            {
                !responseDone 
                ?
                <div className='sendPrompt'>
                    <a href="#" className='button stop-generating' onClick={stopGenerating} style={{background: `linear-gradient(0deg, rgba(var(--theme-mode-rgb-white), 0.80) 0%, rgba(var(--theme-mode-rgb-white), 0.80) 100%), var(--accent-color)`}}><StopIcon opacity={1} /> Stop Generating</a>
                </div>
                :
                (
                    prompt.length > 0
                    ?
                    <div className='sendPrompt'>
                        <a href="#" onClick={e => send(e, prompt)} className="button primary bg-[var(--accent-color)] text-white dark:text-black">{chatData.length > 0 ? 'Send' : 'Start'} <SendIcon color={theme== "dark" ? "black" : "white"} /></a>
                    </div>
                    :
                    <div className='sendPrompt'>
                        <a href="#" onClick={e => send(e, prompt)} className="button primary">{chatData.length > 0 ? 'Send' : 'Start'} <SendIcon color={theme== "dark" ? "gray" : "#737373"} /></a>
                    </div>
                )
            }
        </div>
    )
})

export default PromptInputBox